var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import keydown from 'react-keydown';
import { observer } from 'mobx-react';
import { makeObservable } from 'mobx';
import { AbfragerBottomLine } from '../../layout/answerbottom/AbfragerBottomLine';
import { AbfragerBottomButton } from '../../layout/answerbottom/AbfragerBottomButton';
import { bound } from '../../../../utils/decorators/basic';
let AbfragerCycleEndBottomLine = class AbfragerCycleEndBottomLine extends React.PureComponent {
    constructor(props) {
        super(props);
        makeObservable(this);
    }
    get app() {
        return this.props.question.context.app;
    }
    get center() {
        return React.createElement("span", { style: { marginLeft: 10 } }, "Weiter geht's mit der \"Enter\"-Taste...");
    }
    get right() {
        return (React.createElement(AbfragerBottomButton, { typ: 3, onClick: () => window.location.reload() }, "Neuen Lerndurchgang starten"));
    }
    render() {
        const { question } = this.props;
        return React.createElement(AbfragerBottomLine, { center: this.center, right: this.right });
    }
    ENTER_KEY = 13;
    handleKeyDown(event) {
        if (event.keyCode === this.ENTER_KEY) {
            this.startNextCycle();
        }
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    startNextCycle(event = null) {
        this.app.directive.directiveStartNewCycle.startNewCycleByReload();
    }
};
__decorate([
    bound
], AbfragerCycleEndBottomLine.prototype, "handleKeyDown", null);
__decorate([
    keydown('enter') // replace by keydownGlobal once available: https://github.com/glortho/react-keydown/pull/71
], AbfragerCycleEndBottomLine.prototype, "startNextCycle", null);
AbfragerCycleEndBottomLine = __decorate([
    observer
], AbfragerCycleEndBottomLine);
export { AbfragerCycleEndBottomLine };
